import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage25.module.css";

export default function LaymanPage25() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div
                className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
              >
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>FORCES OF VENUS</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.venus_block_main}>
                <div
                  className={`${styles.venus_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.venus_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_venus/venus_block1_img.webp"
                    /> */}
                    <img className={styles.venus_img1} src={`${process.env.cloud_url}Layman-Symbolism/layman_page_forces_of_venus/venus_block1_img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div class={styles.layman_yellow_commn_header}>
                        <h2>
                        Venus Unveiled: Nurturing Forces of Attraction and Beauty
                        </h2>
                      </div>
                      <p>
                        Venus, a celestial force embedded within the tapestry of
                        <Link href="https://www.divineinfinitebeing.com"> the School of Divine Infinite Being</Link> method and
                        Archetypal Astrology, emerges as the enchanting
                        harbinger of attraction and beauty. Beyond its
                        astronomical significance, Venus holds a mystical sway
                        over the forces that shape our realities, drawing in and
                        materializing expanded presence through the powerful{" "}
                        <i>"Power of Attraction."</i>
                      </p>
                      <p>
                        In the cosmic dance of planetary energies, Venus stands
                        as a counterpart to Jupiter's expansive awareness. While
                        Jupiter broadens our understanding, Venus gracefully
                        pulls the newly expanded presence into being. It acts as
                        a cosmic casting chamber, intricately related to ritual
                        and the manifestation of desires in the tangible realms.
                      </p>

                      <p>
                        The energies of Venus resonate deeply with femininity
                        and the graces of motherhood. Within its cosmic embrace,
                        Venus becomes a force for nurturing and health, opening
                        the doors to an awareness of our bioelectricity and the
                        intricate photon fields that envelop our existence.
                        Venus frames the anatomy of our energy body, extending
                        its healing touch even to the densest form of our
                        electromagnetic selves—the physical body.
                      </p>

                      <p>
                        As a cosmic nurturer, Venus is intimately tied to the
                        concept of love in its deepest forms. It accounts for
                        the beauty that permeates the world and the cosmos,
                        expressed through sensory experiences that enrich our
                        lives. Venus, with its energies, extends beyond the
                        individual and encompasses family and tribe
                        orientations, drawing in the love of our fellow humans
                        and expanding the reach of its cosmic influence.
                      </p>

                      <p>
                        Yet, the forces of Venus can be capricious. Like the
                        Jungian <i>"Devouring Mother"</i> Archetype, Venus may
                        run cold if not balanced and kept healthy. It emphasizes
                        the importance of equilibrium in the dance of attraction
                        and love, ensuring that nurturing energies do not
                        transform into possessiveness or stifling influences.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.venus_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_venus/venus_block2_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/layman_page_forces_of_venus/venus_block2_img.webp`}/>
                  </div>

                  <div className={`${styles.layman_txt_box_wrpr}`}>
                    <div className={styles.layman_txt_box_innr}>
                      <p className={styles.one_sqr_bullt}>
                        In its Archetypal instinct, Venus embodies the{" "}
                        <i>"Influx of Beauty,"</i> a force that transcends the
                        aesthetic to touch the very essence of materialization
                        through love. This archetypal force urges individuals to
                        recognize and channel the energies of attraction and
                        beauty, allowing them to manifest their desires and
                        bring forth tangible realities into existence.
                      </p>

                      <p>
                        As we navigate the celestial realms, Venus beckons us to
                        explore the transformative power of attraction and the
                        healing energies inherent in the forces of beauty. By
                        understanding and balancing the archetypal instinct of
                        Venus, we embark on a journey towards materialization
                        through love, a journey where the cosmic energies of
                        attraction intertwine with the very fabric of our being,
                        drawing forth the beauty that resides within and around
                        us.
                      </p>

                      <div class={styles.layman_yellow_commn_header}>
                        <h2>
                        Astrological Features:
                        </h2>
                      </div>
                      <div className={styles.bullet_wrapper}>
                        <p>
                          <b>Occult Forces:</b> Venus is a significant Occult force
                          within <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being</Link> method and
                          Archetypal Astrology, representing cosmic energies
                          associated with attraction and beauty.
                        </p>
                        <p>
                        <b>Power of Attraction:</b> Venus is closely related to the
                          <i>"Power of Attraction,"</i> drawing in and materializing
                          expanded presence through cosmic forces.
                        </p>
                        <p>
                        <b>Ritual Connection:</b> Venus has a special relationship to
                          ritual, acting as a casting chamber for the
                          manifestation of desires and intentions.
                        </p>
                        <p>
                        <b>Femininity and Motherhood:</b> Energies of Venus are
                          associated with femininity and the graces of
                          motherhood, nurturing and sustaining life forces.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.venus_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_venus/venus_block3_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/layman_page_forces_of_venus/venus_block3_img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_wrapper} `}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>Bioelectricity and Photon Fields:</b> Venus opens
                        doors to the awareness of bioelectricity and photon
                        fields, framing the anatomy of the energy body and
                        facilitating healing.
                      </p>

                      <p>
                        <b>Love and Beauty:</b> Venus is intricately tied to the
                        deepest forms of love and accounts for the beauty in the
                        world and cosmos, manifested through sensory
                        experiences.
                      </p>
                      <p>
                        <b>Family and Tribe Orientation:</b> Venus extends its
                        energies to family and tribe orientations, drawing in
                        the love of fellow humans and expanding its cosmic
                        influence.
                      </p>
                      <p>
                        <b>Balancing Love:</b> Venus, if not balanced, can
                        embody the Jungian <i>"Devouring Mother"</i> Archetype, running
                        cold and emphasizing the importance of healthy and
                        balanced expressions of love.
                      </p>
                      <p>
                        <b>Archetypal Instinct:</b> Venus embodies the <i>"Influx
                        of Beauty"</i> as an Archetypal instinct, representing a
                        force that transcends the aesthetic and manifests
                        through materialization via love.
                      </p>
                      <p>
                        <b>Materialization through Love:</b> The archetypal
                        impulse of Venus is directed towards <i>"Materialization
                        through Love,"</i> urging individuals to recognize and
                        channel the energies of attraction and beauty for
                        tangible manifestations.
                      </p>
                      <p>
                        <b>Expanded Presence:</b> Venus gracefully pulls the
                        expanded presence into being, complementing the
                        expansive awareness associated with Jupiter.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={styles.green_sec_cmn_main_wrp}>
                    <Link href="/rota-the-wheel">
                      <div className={styles.green_sec_cmn_sub_wrp}>
                        <h1>
                          The Astrological Tarot association for Venus is The
                          <br />
                          Empress. See our alchemical ROTA here.
                        </h1>
                      </div>
                    </Link>
                </div>
              </div>
            </div>

            {/* <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_venus/layman_page25_block4_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div> */}

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_venus/layman_page25_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_venus/layman_page25_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_venus/layman_page25_block3_demo_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_forces_of_venus/layman_page25_block4_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
